module.exports = __webpack_public_path__ + "MM.png?fc20914487571d8ae4a65ecaf586dd2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/MM.png
// module id = 383
// module chunks = 0